import { Sun, Moon, Monitor } from "lucide-react";
import { useTheme } from "@/lib/useTheme";

const ICONS = {
  system: Monitor,
  light: Sun,
  dark: Moon,
};

const LABELS = {
  system: "Theme: follows system",
  light: "Theme: light",
  dark: "Theme: dark",
};

export default function ThemeToggle() {
  const { mode, cycle } = useTheme();
  const Icon = ICONS[mode];
  return (
    <button
      type="button"
      onClick={cycle}
      aria-label={LABELS[mode]}
      title={LABELS[mode]}
      data-testid="theme-toggle-btn"
      className="touch card"
      style={{
        width: 44,
        height: 44,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: 999,
        background: "var(--surface)",
      }}
    >
      <Icon size={18} strokeWidth={1.75} color="var(--text)" aria-hidden="true" />
    </button>
  );
}
